import { render, staticRenderFns } from "./add_country.vue?vue&type=template&id=a112dda4&"
import script from "./add_country.vue?vue&type=script&lang=js&"
export * from "./add_country.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports